import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-m-2" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-4" }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  for: "mondrian-schema-select",
  class: "kn-material-input-label"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "p-col-8" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "p-field p-col-4"
}
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = {
  for: "cube-select",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, [
          _createVNode(_component_Dropdown, {
            id: "mondrian-schema-select",
            class: "kn-material-input",
            modelValue: _ctx.selectedMondrianSchema,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedMondrianSchema = $event)),
            options: _ctx.mondrianSchemas,
            optionLabel: "name",
            onChange: _ctx.onMondrianSchemaSelected
          }, null, 8, ["modelValue", "options", "onChange"]),
          _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('documentExecution.documentDetails.designerDialog.selectMondrianSchema')), 1)
        ])
      ]),
      _hoisted_6,
      (_ctx.selectedMondrianSchema)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("span", _hoisted_8, [
              _createVNode(_component_Dropdown, {
                id: "cube-select",
                class: "kn-material-input",
                modelValue: _ctx.selectedCube,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedCube = $event)),
                options: _ctx.cubes,
                onChange: _ctx.onCubeSelected
              }, null, 8, ["modelValue", "options", "onChange"]),
              _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('documentExecution.documentDetails.designerDialog.selectCube')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}